import baseApi, {
    transformResponseFromData,
    // transformResponseFromMessage,
    provideTags,
    provideTag,
} from 'store/slices/api/baseApi'

const usersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getUsers: build.query({
            query: () => ({url: 'users', method: 'GET'}),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTags('User', result),
        }),
        getUser: build.query({
            query: ({userId}) => ({
                url: `users/${userId}`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTag('User', result),
        }),
        getProfile: build.query({
            query: () => ({url: 'users/profile', method: 'GET'}),
            providesTags: ['Profile'],
        }),
        updateProfile: build.mutation({
            query: (body) => ({
                url: `users/profile`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Profile'],
        }),
        saveUser: build.mutation({
            query: (user) => {
                return {
                    url: `users/${user._id}`,
                    method: 'PUT',
                    body: user,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('User', result),
        }),
        deleteUser: build.mutation({
            query: ({userId}) => {
                return {
                    url: `users/${userId}`,
                    method: 'DELETE',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('User'),
        }),
    }),
    overrideExisting: false,
})

export default usersApi

export const {
    useGetProfileQuery,
    useUpdateProfileMutation,
    useGetUserQuery,
    useGetUsersQuery,
    useSaveUserMutation,
    useModifyUserInfoMutation,
    useDeleteUserMutation,
} = usersApi
